export enum AddonParameterType {
  ELEMENT="ELEMENT",
  TEST_DATA = "TEST_DATA",
  TEST_DATA_PROFILE = "TEST_DATA_PROFILE",
  TEST_DATA_SET = "TEST_DATA_SET",
  ENVIRONMENT_DATA = "ENVIRONMENT_DATA"
}
